import { Record } from 'immutable';

const RoomTypeRateSummaryRecord = Record({
  roomType: null,
  roomRate: null,
  totalNights: 0,
  totalRevenue: 0
});

export class RoomTypeRateSummary extends RoomTypeRateSummaryRecord {
  roomType: string;
  roomRate: number;
  totalNights: number;
  totalRevenue: number;
}

/**
 * RoomTypeRateSummary has multiple fields
 * This method defines sort algorithm for List<RoomTypeRateSummary>
 *
 * 1. Sort by room type. e.g king, queen, etc
 * 2. If room types are equal:
 *    - Sort by room rate
 *
 * Returns a number bc that is what is used for immutable-js list sort
 *
 * immutable-js List sort()
 * https://facebook.github.io/immutable-js/docs/#/List/sort
 *
 * @param a {RoomTypeRateSummary}
 * @param b {RoomTypeRateSummary}
 * @returns number
 */
export const RoomTypeRateSummarySort = (a: RoomTypeRateSummary, b: RoomTypeRateSummary): number => {

  // check if roomType is equal
  if (a.roomType.localeCompare(b.roomType) !== 0) {
    return a.roomType.localeCompare(b.roomType);
  }

  // fallback: sort by roomRate and cast to number for
  // immutable-js sort
  return a.roomRate < b.roomRate ? -1 : 1;
};



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/models/room-type-rate-summary.ts